import { css, StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import backgroundPhone from '../../assets/pro-part-phone.jpg'
import background from '../../assets/pro-part.jpg'
import WidgetHomeHeader from '../../components/Widget/WidgetHomeHeader'
import { MEDIA_MIN_LG } from '../../lib/breakpoints'
import {
  COLOR_BLACK,
  COLOR_GREEN_NEON,
  COLOR_PINK_NEON,
  COLOR_WHITE,
} from '../../lib/colors'
import { leToBr } from '../../utils/Utils'
import RegisterWatcher from '../Watcher/RegisterWatcher'
import './style.css'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: COLOR_BLACK,
    '@media (max-width: 992px)': {
      height: 'auto',
      flexDirection: 'column',
    },
  },
  backgroundImage: {
    position: 'absolute',
    objectPosition: 'bottom',
    objectFit: 'cover',
    width: '108vw',
    marginLeft: '-4vw',
    height: '130vh',

    '@media (max-width: 992px)': {
      position: 'absolute',
      height: '150vh',
    },
  },
  navbar: {
    position: 'absolute',
    zIndex: 10,
  },
  panel: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    color: COLOR_WHITE,
    position: 'relative',
    '@media (max-width: 992px)': {
      height: '68vh',
    },
    '@media (max-width: 480px)': {
      height: '74vh',
    },
  },
  content: {
    padding: '5em 0 3em 4em',
    position: 'absolute',
    zIndex: 2,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    fontWeight: 700,
    color: COLOR_WHITE,
    '@media (max-width: 480px)': {
      position: 'relative',
      padding: '120px 0px 20px 30px',
    },
    [MEDIA_MIN_LG]: {
      padding: '5em 0 1em 4em',
    },
  },
  title: {
    margin: '0',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: 120,
    lineHeight: '120px',
    display: 'flex',
    alignItems: 'center',
    color: 'white',
    '@media (max-width: 992px)': {
      fontSize: 100,
    },
    '@media (max-width: 480px)': {
      position: 'relative',
      fontWeight: '700',
      fontSize: 60,
      width: 'auto',
      lineHeight: '50px',
    },
  },
  category: {
    fontSize: '5em',
    margin: 0,
    fontWeight: 700,
    '@media (max-width: 992px)': {
      fontSize: '4em',
    },
    '@media (max-width: 480px)': {
      fontSize: '18vw',
    },
  },
  pro: {
    color: COLOR_GREEN_NEON,
  },
  individual: {
    color: COLOR_PINK_NEON,
  },
  description: {
    margin: 0,
    paddingRight: '10%',
    fontWeight: 700,
    opacity: '80%',
    color: COLOR_WHITE,
    fontSize: '2em',
    '@media (max-width: 480px)': {
      fontSize: '1em',
      width: '100%',
      paddingTop: '50px',
      paddingBottom: 0,
    },
    '@media (max-width: 1200px)': {
      fontSize: '1.3em',
    },
    '@media (min-width: 1360px)': {
      fontSize: '1.7em',
    },
  },
  goContainer: {
    alignSelf: 'flex-end',
  },
  go: {
    fontWeight: 700,
    color: COLOR_WHITE,
    fontSize: '2.5em',
    textDecoration: 'underline',
    textDecorationThickness: '0.2em',
    lineHeight: '1em',
    margin: '0em 1.5em 0em auto',
    cursor: 'pointer',
  },
  underlinePro: {
    textDecorationColor: COLOR_GREEN_NEON,
  },
  underlineIndividual: {
    textDecorationColor: COLOR_PINK_NEON,
  },
})

function Landscape() {
  const { t } = useTranslation('translation')
  const navigate = useNavigate()

  const [isRegisterOpened, setRegisterOpened] = useState(false)

  const handleGoProfessional = () => {
    navigate('/pro')
  }

  const handleGoIndividual = () => {
    navigate('/particulier')
  }

  const onRegisterClose = () => {
    setRegisterOpened(false)
  }

  return (
    <>
      <WidgetHomeHeader
        smallSize={window.innerWidth < 480 ? true : false}
        dynamicStyle={styles.navbar}
      />
      <div className={css(styles.container)}>
        <img
          src={window.innerWidth <= 1024 ? backgroundPhone : background}
          className={css(styles.backgroundImage)}
          alt="background be viewer"
          width="auto"
          height="auto"
        />
        <div className={css(styles.panel)}>
          <div className={css(styles.content)}>
            <div className={css(styles.beAViewerProText)}>
              <h1 className={css(styles.title)}>
                {t('pages.beAViewer.beA')}
                <br /> {t('pages.beAViewer.viewer')}
              </h1>
              <h1 className={css(styles.category, styles.pro)}>
                {t('pages.beAViewer.pro')}
              </h1>
            </div>

            <p
              className={css(styles.description)}
              style={{
                textShadow:
                  '2px 0 #000, -2px 0 #000, 0 2px #000, 0 -2px #000, 1px 1px #000, -1px -1px #000, 1px -1px #000, -1px 1px #000',
              }}
            >
              {leToBr(t('pages.beAViewer.proDescription'))}
            </p>
            <span
              className={css(styles.goContainer) + ' GOviewerpro'}
              onClick={handleGoProfessional}
            >
              <p className={css(styles.go, styles.underlinePro)}>
                {t('pages.beAViewer.go')}
              </p>
            </span>
          </div>
        </div>
        <div className={css(styles.panel)}>
          <div className={css(styles.content)}>
            <h1 className={css(styles.title)}>
              {t('pages.beAViewer.beA')}
              <br /> {t('pages.beAViewer.viewer')}
            </h1>
            <h1 className={css(styles.category, styles.individual)}>
              {t('pages.beAViewer.individual')}
            </h1>
            <p className={css(styles.description)}>
              {leToBr(t('pages.beAViewer.individualDescription'))}
            </p>
            <span
              className={css(styles.goContainer) + ' GOviewerpaticulier'}
              onClick={handleGoIndividual}
            >
              <p className={css(styles.go, styles.underlineIndividual)}>
                {t('pages.beAViewer.go')}
              </p>
            </span>
          </div>
        </div>
      </div>
      <RegisterWatcher isOpened={isRegisterOpened} onClose={onRegisterClose} />
    </>
  )
}

export default Landscape
